import { useEffect } from "react";
import Banner from '../../assets/disclaimer-banner.png'

const Disclaimer = () => {

  useEffect(() => {
    window.scrollTo(0,0)
  }, [])

  return <div className="py-12 sm:py-8 font-notosans sm:px-10 px-3">
    <div className="flex flex-col sm:flex-row justify-between items-center">
      <p className="banner-text-shadow text-4xl text-center sm:text-left sm:text-6xl text-[#044e87ea] tracking-wider font-bold z-[2]">
        Disclaimer
      </p>
      <img
        src={Banner}
        alt="banner"
        className="h-[300px] w-[auto] scale-110 sm:scale-100 sm:w-[auto] sm:h-[250px] md:h-[300px] lg:h-[380px] xl:h-[420px] z-[1]"
      />
      <div className="w-full h-[400px] sm:h-[350px] md:h-[400px] lg:h-[500px] object-cover absolute top-0 left-0 z-[-1] bg-gradient-to-b sm:bg-gradient-to-r to-[#168ce7ea] via-[#50b4e780] from-[#fff0]">

      </div>
    </div>
    <p className="text-lg font-notosans mt-4">
      This website may contain other proprietary notices and copyright information, the terms of which must be observed and followed. Information on this website may contain technical inaccuracies or typographical errors. Information may be changed or updated without notice. Flint may also make improvements and/or changes in the products and/or the programs described in this information at any time without notice.
      Flint does not want to receive confidential or proprietary information from you through our website. Please note that any information or material sent to us will be deemed NOT to be confidential. By sending us any information or material, you grant Flint an unrestricted, irrevocable license to use, reproduce, display, perform, modify, transmit and distribute those materials or information, and you also agree that Flint is free to use any ideas, concepts, know-how or techniques that you send us for any purpose.
    </p>
    <p className="text-lg font-notosans mt-5">
      Flint makes no representations whatsoever about any other Website which you may access through this one. In addition, a link to a non-Flint website does not mean that Flint endorses or accepts any responsibility for the content, or the use of such website. It is up to you to take precautions to ensure that whatever you select for your use is free of such items as viruses, worms, trojan horses and other items of a destructive nature.
    </p>
    <p className="text-lg font-notosans mt-5">
      In no event will Flint be liable to any party for any direct, indirect, special or other consequential damages for any use of this website, or on any other hyperlinked website, including, without limitation, loss of programs or other data on your information handling system or otherwise.
    </p>
    <p className="text-lg font-notosans mt-5">
      All information is provided by Flint Infotech Limited on an “as is" basis only. Flint provides no representations and warranties, express or implied. Logos and names used in the website are trademarks of their respective owners.
    </p>
  </div>
}

export default Disclaimer;